import { render } from "./AddSummaryToTrainingForm.vue?vue&type=template&id=e9cc350e"
import script from "./AddSummaryToTrainingForm.vue?vue&type=script&lang=js"
export * from "./AddSummaryToTrainingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__